import { REQUEST_STATUS, BADGE_VARIANTS } from "@src/constants";
import { TeamLeadRequestOverviewItem, Employee } from "@src/types";
import { ValueGetterParams } from "ag-grid-community";
import dayjs from "dayjs";
import Cookies from "universal-cookie";

const cookies = new Cookies();
const employeeCookie: Employee = cookies.get("loggedInuser");

export function showBadge(
  primaryTeamLeadEmployeeId: number,
  status: string
): boolean {
  return (
    !employeeCookie?.applicationRoles.includes("Team Lead") ||
    status !== REQUEST_STATUS.IN_PROGRESS
  );
}

export function getBadgeVariant(params: ValueGetterParams): string | undefined {
  const shouldShowBadge: boolean = showBadge(
    params.data.primaryTeamLeadEmployeeId,
    params.data.status
  );
  if (!shouldShowBadge) return;
  if (params.data.outdated) return BADGE_VARIANTS.OUTDATED;
  if (params.data.isDeclined) return BADGE_VARIANTS.DECLINED;
  if (params.data.commentAvailable && !params.data.commentReadByEmployee)
    return BADGE_VARIANTS.COMMENT;
  if (params.data.isUpdated) return BADGE_VARIANTS.UPDATED;
}

export function getBadgeClass(variant: string): string {
  switch (variant) {
    case BADGE_VARIANTS.OUTDATED:
      return "outdatedBadge";
    case BADGE_VARIANTS.COMMENT:
      return "commentBadge";
    case BADGE_VARIANTS.DECLINED:
    case BADGE_VARIANTS.UPDATED:
      return "notificationCount";
    default:
      return "";
  }
}

export function isDateInRange(
  date: Date,
  rangeStartDate: Date,
  rangeEndDate: Date
): boolean {
  return dayjs(date).isBetween(rangeStartDate, rangeEndDate, "days", "[]");
}

export function mapToRowData(
  requests: TeamLeadRequestOverviewItem[]
): TeamLeadRequestOverviewItem[] {
  return requests?.map((request) => ({
    ...request,
    region: request.region || "N.A.",
  }));
}
